/**
 * The X (Twitter) app opens links in its own in-app browser, which Google
 * Identity Services refuses (disallowed_useragent), so Google sign-in cannot
 * complete there. The app's user agent still carries the Twitter markers:
 * "Twitter for iPhone" / "Twitter for iPad" on iOS, "TwitterAndroid" on Android.
 */
const X_IN_APP_PATTERN = /TwitterAndroid|Twitter for i/i;

export const isXInAppBrowser = (userAgent: string = typeof navigator === "undefined" ? "" : navigator.userAgent): boolean =>
  X_IN_APP_PATTERN.test(userAgent);
